import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dffd7ac0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "device-info-page" }
const _hoisted_2 = { class: "page-content" }
const _hoisted_3 = { class: "device-summary" }
const _hoisted_4 = {
  class: "summary-icon",
  "aria-hidden": "true"
}
const _hoisted_5 = { class: "summary-copy" }
const _hoisted_6 = { class: "status-line" }
const _hoisted_7 = {
  class: "clock-card",
  "aria-live": "polite"
}
const _hoisted_8 = { class: "clock-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "当前时间", -1))
const _hoisted_10 = { class: "section-grid" }
const _hoisted_11 = { class: "section-header" }
const _hoisted_12 = {
  class: "section-icon",
  "aria-hidden": "true"
}
const _hoisted_13 = { class: "info-list" }
const _hoisted_14 = { class: "privacy-note" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 本页仅读取当前设备中的诊断信息，不会自动上传。 ")
const _hoisted_16 = { class: "copy-footer" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 复制全部调试信息 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: "设备信息",
      "left-text": "返回",
      "left-arrow": "",
      onClickLeft: _ctx.goBack
    }, null, 8, ["onClickLeft"]),
    _createElementVNode("main", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_van_icon, { name: "phone-o" })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", {
              class: _normalizeClass(["status-dot", { offline: !_ctx.online }])
            }, null, 2),
            _createTextVNode(" " + _toDisplayString(_ctx.online ? "网络已连接" : "网络未连接"), 1)
          ]),
          _createElementVNode("h1", null, _toDisplayString(_ctx.deviceModel || "当前设备"), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.hostType) + " 客户端 · 调试信息实时更新", 1)
        ])
      ]),
      _createElementVNode("section", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("strong", null, _toDisplayString(_ctx.formattedCurrentTime), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleSections, (section) => {
          return (_openBlock(), _createElementBlock("section", {
            key: section.title,
            class: "info-section"
          }, [
            _createElementVNode("header", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, [
                _createVNode(_component_van_icon, {
                  name: section.icon
                }, null, 8, ["name"])
              ]),
              _createElementVNode("h2", null, _toDisplayString(section.title), 1),
              _createElementVNode("span", null, _toDisplayString(section.items.length) + " 项", 1)
            ]),
            _createElementVNode("dl", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.items, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.label,
                  class: "info-row"
                }, [
                  _createElementVNode("dt", null, _toDisplayString(item.label), 1),
                  _createElementVNode("dd", {
                    class: _normalizeClass({ 'code-value': item.code })
                  }, _toDisplayString(item.value), 3)
                ]))
              }), 128))
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("p", _hoisted_14, [
        _createVNode(_component_van_icon, { name: "shield-o" }),
        _hoisted_15
      ])
    ]),
    _createElementVNode("footer", _hoisted_16, [
      _createVNode(_component_van_button, {
        type: "primary",
        block: "",
        round: "",
        icon: "description",
        onClick: _ctx.copyInfo
      }, {
        default: _withCtx(() => [
          _hoisted_17
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}